<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import adminJobfairService from "../../services/jobfair/adminJobfairService";
import SNBAdmin from "../../../../layouts/nav/SNBAdmin.vue";
import { useAlertStore } from "../../../../stores/alertStore";
const { $alert } = useAlertStore();
const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();
const { $toast } = getCurrentInstance().appContext.config.globalProperties;

const currentURL = window.location.host;

onMounted(() => {
    const { id } = route.params;
    if (!id) {
        router.push({ name: "OjfList" });
    } else {
        retrieveOnlineJobFair(id);
    }
});

const ojfDetail = ref({});

const tabIndex = ref(0);

const deleteYn = ref(true);

const retrieveOnlineJobFair = (ojfId) => {
    loadingStore.loading = true;
    adminJobfairService.retrieveOnlineJobFair(ojfId)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                ojfDetail.value = result;
                await retrieveRecruitmentHallCountByOjfId(ojfId);
                await retrieveEntryCountByOjfId(ojfId);
            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

const retrieveRecruitmentHallCountByOjfId = async (ojfId) => {
    loadingStore.loading = true;
    await adminJobfairService.retrieveRecruitmentHallCountByOjfId(ojfId)
        .then((res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                if ( result.corpJoinState11 != "0" ) {
                    loadingStore.loading = false;
                    deleteYn.value = false;
                }
            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

const retrieveEntryCountByOjfId = async (ojfId) => {
    loadingStore.loading = true;
    await adminJobfairService.retrieveEntryCountByOjfId(ojfId)
        .then((res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                if ( result.joinState11 != "0" ) {
                    loadingStore.loading = false;
                    deleteYn.value = false;
                }
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};


// 행사 복사. 현재 보고있는 행사정보를 복사한 행사 등록 페이지로 이동
const copyOjf = async () => {
    router.push({ name: "OjfCreate", params: { id: ojfDetail.value.ojfId } });
};

// 행사 수정
const editOjf = () => {
    router.push({ name: "OjfUpdate", params: { id: ojfDetail.value.ojfId } });
};

// 행사 삭제
const deleteOjf = () => {
    loadingStore.loading = true;
    adminJobfairService.deleteOnlineJobFair(ojfDetail.value)
        .then(async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                const ok = await $alert(["행사가 삭제되었습니다."]);
                if (ok) {
                    goOjfList();
                }
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 행사 목록으로 이동
const goOjfList = () => {
    router.push({ name: "OjfList" });
};
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>{{ ojfDetail.ojfName }}</h3>
        </div>
        <div class="list-top space-between">
            <KSASecondaryButton class="gray_button" text="목록" @click="goOjfList" />
            <div>
                <KSASecondaryButton class="gray_button ml-xs" text="행사 복사" @click="copyOjf" />
                <KSASecondaryButton class="gray_button ml-xs" text="행사 수정" @click="editOjf" />
                <KSASecondaryButton class="red_button ml-xs" text="행사 삭제" @click="deleteOjf" :disabled="!deleteYn" />
            </div>
        </div>
        <KSATab style="grid-template-columns: repeat(5, 1fr);" class="mb-lg"
                :options="[
                    {label:'행사 정보', value:0},
                ]"
        />

        <!-- s: 행사 정보 -->
        <div v-show="tabIndex === 0">
            <div class="table-form">
                <table class="vertical">
                    <colgroup>
                        <col width="200px" />
                        <col />
                    </colgroup>
                    <tr>
                        <th>이미지</th>
                        <td>
                            <div v-if="ojfDetail.ojfThombDir" style="width: 160px; height: 160px;">
                                <KSAImage :src="ojfDetail.ojfThombDir" />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>행사구분</th>
                        <td>
                            <span v-if="ojfDetail.ojfGb === '01'">기업공채관</span>
                            <span v-else>채용박람회</span>
                        </td>
                    </tr>
                    <tr>
                        <th>행사명</th>
                        <td>
                            <span>{{ ojfDetail.ojfName }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>접수기간</th>
                        <td>
                            <span>{{ $yyyymmdd(ojfDetail.regStartYmd) }} ~ {{ $yyyymmdd(ojfDetail.regEndYmd)
                                }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>행사기간</th>
                        <td>
                            <span>{{ $yyyymmdd(ojfDetail.ojfStartYmd) }} ~ {{ $yyyymmdd(ojfDetail.ojfEndYmd)
                                }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>면접기간</th>
                        <td>
                            <span>{{ ojfDetail.ojfIntvDay }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>장소</th>
                        <td>
                            <span>{{ ojfDetail.ojfPlace }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>주최</th>
                        <td>
                            <span>{{ ojfDetail.ojfHost }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>행사 소개</th>
                        <td v-html="ojfDetail.ojfIntro" class="editor-wrap"></td>
                    </tr>
                    <tr>
                        <th>간략 안내</th>
                        <td>
                            <span>{{ ojfDetail.summary }}</span>
                        </td>
                    </tr>
                    <tr>
                        <th>공개/비공개 설정</th>
                        <td>
                            {{ ojfDetail.openYn === "Y" ? "공개" : "비공개" }}
                            <small v-if="ojfDetail.openYn === 'N'">
                                ({{ currentURL }}/matching/jobFair/sdetail/{{ ojfDetail.ojfUuid }})
                            </small>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <!-- e: 행사 정보 -->
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.textarea-box {
    height: 100px;
}
</style>